import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DepartmentUsersAdminEffects } from '@modules/department/components/department-users-admin/effects/department-users-admin.effects';
import { provideEffects } from '@ngrx/effects';
import { NavigationActionTiming, provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideState } from '@ngrx/store';
import { ActiveClientEffects } from './active-client/active-client.effects';
import { activeClientReducer } from './active-client/active-client.reducer';
import { ACTIVE_CLIENT_FEATURE_KEY } from './active-client/active-client.selectors';
import { AttachmentsEffects } from './attachments/attachments.effects';
import { attachmentsReducer } from './attachments/attachments.reducer';
import { ATTACHMENTS_FEATURE_KEY } from './attachments/attachments.selectors';
import { clientsReducer } from './clients/clients.reducer';
import { CLIENTS_FEATURE_KEY } from './clients/clients.selectors';
import { DepartmentsEffects } from './departments/departments.effects';
import { departmentsReducer } from './departments/departments.reducer';
import { DEPARTMENTS_FEATURE_KEY } from './departments/departments.selectors';
import { drawerReducer } from './drawer/drawer.reducer';
import { DRAWER_FEATURE_KEY } from './drawer/drawer.selectors';
import { ExaminationsEffects } from './examinations/examinations.effect';
import { examinationsReducer } from './examinations/examinations.reducer';
import { EXAMINATIONS_FEATURE_KEY } from './examinations/examinations.selector';
import { ExportsEffects } from './exports/exports.effects';
import { exportsReducer } from './exports/exports.reducer';
import { EXPORTS_FEATURE_KEY } from './exports/exports.selectors';
import { LabelsEffect } from './labels/labels.effects';
import { labelsReducer } from './labels/labels.reducer';
import { LABELS_FEATURE_KEY } from './labels/labels.selectors';
import { LicensesEffects } from './licenses/licenses.effects';
import { licensesReducer } from './licenses/licenses.reducer';
import { LICENSES_FEATURE_KEY } from './licenses/licenses.selectors';
import { LifeCycleEffects } from './life-cycle/life-cycle.effects';
import { lifeCycleReducer } from './life-cycle/life-cycle.reducer';
import { LIFE_CYCLE_FEATURE_KEY } from './life-cycle/life-cycle.selectors';
import { NotificationsEffects } from './notifications/notifications.effects';
import { PatientsEffects } from './patients/patients.effects';
import { patientsReducer } from './patients/patients.reducer';
import { PATIENTS_FEATURE_KEY } from './patients/patients.selectors';
import { CustomRouterStateSerializer } from './router/router-state.serializer';
import { ROUTER_FEATURE_KEY } from './router/router.selectors';
import { SadmEffects } from './sadm/sadm.effects';
import { sadmReducer } from './sadm/sadm.reducer';
import { SADM_FEATURE_KEY } from './sadm/sadm.selectors';
import { SequencesEffects } from './sequences/sequences.effects';
import { sequencesReducer } from './sequences/sequences.reducer';
import { SEQUENCES_FEATURE_KEY } from './sequences/sequences.selectors';
import { syncReducer } from './sync/sync.reducer';
import { SYNC_FEATURE_KEY } from './sync/sync.selectors';
import { TelemonitoringsEffects } from './telemonitorings/telemonitorings.effects';
import { telemonitoringsReducer } from './telemonitorings/telemonitorings.reducer';
import { TELEMONITORINGS_FEATURE_KEY } from './telemonitorings/telemonitorings.selectors';
import { usersReducer } from './users/users.reducer';
import { USERS_FEATURE_KEY } from './users/users.selectors';
import { VideoUploadsEffects } from './video-uploads/video-uploads.effects';
import { videoUploadsReducer } from './video-uploads/video-uploads.reducer';
import { VIDEO_UPLOADS_FEATURE_KEY } from './video-uploads/video-uploads.selectors';

export const provideStoreFeatures = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideState(LIFE_CYCLE_FEATURE_KEY, lifeCycleReducer),
    provideState(ACTIVE_CLIENT_FEATURE_KEY, activeClientReducer),
    provideState(CLIENTS_FEATURE_KEY, clientsReducer),
    provideState(DEPARTMENTS_FEATURE_KEY, departmentsReducer),
    provideState(DRAWER_FEATURE_KEY, drawerReducer),
    provideState(LABELS_FEATURE_KEY, labelsReducer),
    provideState(LICENSES_FEATURE_KEY, licensesReducer),
    provideState(PATIENTS_FEATURE_KEY, patientsReducer),
    provideState(SADM_FEATURE_KEY, sadmReducer),
    provideState(SEQUENCES_FEATURE_KEY, sequencesReducer),
    provideState(TELEMONITORINGS_FEATURE_KEY, telemonitoringsReducer),
    provideState(USERS_FEATURE_KEY, usersReducer),
    provideState(EXPORTS_FEATURE_KEY, exportsReducer),
    provideState(ROUTER_FEATURE_KEY, routerReducer),
    provideState(ATTACHMENTS_FEATURE_KEY, attachmentsReducer),
    provideState(EXAMINATIONS_FEATURE_KEY, examinationsReducer),
    provideState(VIDEO_UPLOADS_FEATURE_KEY, videoUploadsReducer),
    provideState(SYNC_FEATURE_KEY, syncReducer),
    provideRouterStore({
      serializer: CustomRouterStateSerializer,
      navigationActionTiming: NavigationActionTiming.PostActivation,
    }),
    provideEffects([
      ActiveClientEffects,
      AttachmentsEffects,
      DepartmentsEffects,
      ExaminationsEffects,
      ExportsEffects,
      LabelsEffect,
      LicensesEffects,
      LifeCycleEffects,
      NotificationsEffects,
      PatientsEffects,
      SadmEffects,
      SequencesEffects,
      TelemonitoringsEffects,
      DepartmentUsersAdminEffects,
      VideoUploadsEffects,
    ]),
  ]);
